<template>
<div class="menu-container">

  <div class="menu">
    <div @click="closeMenu" class="close">
      <img class="cancel" src="@/assets/images/cancel.svg"/>
    </div>
    <div class="menu-grid">
      <div class="menu-links-wrapper">
        <div class="menu-title">{{ $t('message.menu') }}</div>
        <div class="menu-block">
          <div @click="navigateTo('/#introduction', false)" class="menu-block-item">{{ $t('message.Noah_Piugattuk_s_Sto')}}</div>
          <div @click="navigateTo('/explore-the-land', false)" class="menu-block-item">{{ $t('message.Explore_the_Land')}}</div>
        </div>
        <div class="menu-block">
          <div @click="navigateTo('/storytellers')" class="menu-block-item">{{ $t('message.STORYTELLERS')}}</div>
          <div @click="navigateTo('/about')" class="menu-block-item">{{ $t('message.About')}}</div>
          <div @click="navigateTo('/thank-you')" class="menu-block-item">{{ $t('message.Thank_you')}}</div>
        </div>
        <div class="menu-block">

          <div class="menu-block-item">
            <a href="http://www.isuma.tv/noah-piugattuk">
              <span class="menu-block-item-label">
                {{ $t('message.The_movie')}}
              </span>
              <span class="icon-external-link">
                <img src="@/assets/images/chevron-up.svg">
              </span>
            </a>
          </div>

          <div class="menu-block-item">
            <a href="http://www.isuma.tv/isuma-book">
              <span class="menu-block-item-label">
                {{ $t('message.The_book')}}
              </span>
              <span class="icon-external-link">
                <img src="@/assets/images/chevron-up.svg">
              </span>
            </a>
          </div>
        </div>
        <div class="mentions">
          {{ $t('message.A_project_by_IsumaK') }} © 2019 <br><br>
          Cover Photo: © Richard Harrington/Library Archives Canada, Courtesy Stephen Bulger Gallery
        </div>
      </div>
      <div class="menu-column column-2">
        <div class="menu-title">
          {{ $t('message.Legend')}}
        </div>
        <div class="legend-grid">
          <div class="legend-column">
            <icon v-for="icon in icons" :key="icon.icon" :icon="icon.icon" :label="$t(`message.${icon.label}`)"/>
          </div>
          <div class="legend-column">
            <animal v-for="animal in animals_1" :key="animal.icon" :icon="animal.icon" :label="$t(`message.${animal.label}`)"/>
          </div>
          <div class="legend-column">
            <animal v-for="animal in animals_2" :key="animal.icon" :icon="animal.icon" :label="$t(`message.${animal.label}`)"/>
          </div>
        </div>

      </div>
    </div>

  </div>

</div>
</template>

<script>
import Icon from './Menu/Icon'
import Animal from './Menu/Animal'
export default {
  name: 'menu',
  components: {
    Icon,
    Animal
  },
  data () {
    return {
      icons: [
        { label: 'igloo', icon: 'igloo' },
        { label: 'tent', icon: 'tent' },
        { label: 'sodhouse', icon: 'sodhouse' },
        { label: 'house', icon: 'house' },
        { label: 'cabin', icon: 'cabin' },
        { label: 'Church', icon: 'church' },
        { label: 'DEW_Line_Antenna', icon: 'dewline' },
        { label: 'Noah_s_story_event', icon: 'highlight' }
      ],
      animals_1: [
        { label: 'Polar_Bear', icon: 'bear' },
        { label: 'Caribou', icon: 'caribou' },
        { label: 'Fox', icon: 'fox' },
        { label: 'Wolf', icon: 'wolf' },
        { label: 'Geese', icon: 'goose' }
      ],
      animals_2: [
        { label: 'Whale', icon: 'whale' },
        { label: 'Seal', icon: 'seal' },
        { label: 'Walrus', icon: 'walrus' },
        { label: 'Fish', icon: 'fish' }
      ]
    }
  },
  methods: {
    closeMenu () {
      this.$store.commit('setMenuOpened', false)
    },
    navigateTo (url, menuStatus = true) {
      if (document.querySelector('.events')) document.querySelector('.events').style.scrollBehavior = 'auto'
      if (url === '/#introduction') window.location.href = './#introduction'
      // if( url === '/explore-the-land') window.location.href = './explore-the-land'
      this.$store.commit('setMenuOpened', menuStatus)
      this.$router.push(url)
      if (document.querySelector('.events')) document.querySelector('.events').style.scrollBehavior = 'smooth'
    }
  }
}
</script>

<style lang="scss">
  .menu-container {
    .mentions {
      font-family: Georgia;
      font-size: 12px;
      letter-spacing: normal;
      color: #18333c;
    }

    pointer-events: auto;
    background-image: url("../assets/images/paper_texture.png");
    background-color: #F1F1F0;
    position: absolute;
    top: 0;
    bottom: 0;
    height: 100%;
    width: 100%;
    .menu {
      margin: 48px 120px;
      .menu-title {
        text-transform: capitalize;
        margin-bottom: 32px;
        font-family: Georgia;
        font-size: 16px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.5;
        letter-spacing: normal;
        color: #7d939a;
      }
      .cancel {
        width: 24px;
        height: 24px;
        cursor: pointer;

      }
      .menu-grid {
        margin-top: 64px;
        display: grid;
        grid-template-columns: auto auto;
        @media only screen and (max-width: 768px) {
          grid-template-columns: auto;
        }
        grid-gap: 24px;
        .menu-links-wrapper {
          display: flex;
          flex-direction: column;
          .menu-block {
            margin-bottom: 47px;
            @media only screen and (max-width: 768px) {
              margin-bottom: 16px;
            }
            .menu-block-item {
              display: flex;
              flex-direction: row;
              align-items: center;
              cursor: pointer;
              font-family: CAPUTTRIAL;
              font-size: 24px;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: normal;
              letter-spacing: normal;
              color: #244a56;
              .icon-external-link  {
                height: 38px;
                width: 34px;
                margin: 1px 8px;
                cursor: pointer;
                img {
                  width: 24px;
                  height: 24px;
                }

              }
            }
          }
        }
      }
    }
  }
  .legend-grid {
    display: grid;
    height: 100%;
    grid-template-columns: auto auto auto;
    grid-gap: 24px;
  }
  @media only screen and (max-width: 768px) {
    .menu-container {
      .menu {
        margin: 28px 20px;
        .menu-block-item {
          font-size: 20px;
        }
      }
      .menu-title {
        display: none
      }
      .close {
        position: absolute;
        top: 24px;
        right: 24px;
      }
    }
    .column-2 {
      display: none;
    }
  }
</style>
